import { SportEventStatus } from "../models/sport-events.model";

export function statusVariantFilter(sportEventStatus: SportEventStatus) {
  switch (sportEventStatus.code) {
    case "started":
      return "primary";
    case "registration":
      return "secondary";
    case "inprogress":
      return "blue-dark";
    case "registration end":
      return "danger";
    case "end":
      return "dark";
  }
}
